import { Data, Effect, flow } from 'effect';
import * as SchemaAttachments from '../../schemas/aspect/attachments';
export { Attachments } from '../../schemas/aspect/attachments';
export class UnknownAttchmentParseError extends Data.TaggedError('@fixtuur/backpack/Attachments/UnknownAttchmentParseError') {
}
export const fromJson = flow(SchemaAttachments.parse, Effect.mapError(e => new UnknownAttchmentParseError({ originalError: e })));
export const fromJsonString = flow(SchemaAttachments.parseJson, Effect.mapError(e => new UnknownAttchmentParseError({ originalError: e })));
